import IFrameBlock from './IFrameBlock';

export default IFrameBlock;
